import React from "react";
import { Box, Typography, Link } from "@mui/material";
import {
  Favorite as FavoriteIcon,
  Email as EmailIcon,
} from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{ py: 2, textAlign: "center", borderTop: "1px solid #ddd", mt: 4 }}
    >
      <Typography variant="body2" color="textSecondary">
        Built with <FavoriteIcon fontSize="small" color="error" /> by{" "}
        <Link
          href="https://www.linkedin.com/in/bohr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bour Abdelhadi
        </Link>
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        Have suggestions or feedback?{" "}
        <Link href="mailto:borabdelhadi@gmail.com" color="inherit">
          Contact me via email{" "}
          <EmailIcon
            fontSize="small"
            sx={{ verticalAlign: "middle", ml: 0.5 }}
          />
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
